export default __webpack_public_path__ + "static/media/Path3537.655aaa42.svg";